import _ from 'lodash/fp';
import moment from 'moment';

const filterConfig = {
  filter(home, { values }) {
    // const currentDate = moment(_.get('moveInDate', home)).format('YYYY-MM-DD');
    // const newDate = moment(currentDate).add(90, 'days').format('YYYY-MM-DD');
    const today = moment().add(90, 'days').format('YYYY-MM-DD');

    return (values || [])
      .map(v => v.value)
      .includes(moment(today).isAfter(moment(_.get('moveInDate', home))));
  },
  collectValues(homes) {
    const today = moment().add(90, 'days').format('YYYY-MM-DD');
    const quickMoveInHome = _.flow(
      _.map(home => ({
        value: moment(today).isAfter(_.get('moveInDate', home)),
      })),
      _.uniqBy('value'),
      _.sortBy('value'),
    )(homes);
    return quickMoveInHome;
  },
  labelRender: ({ value }) => (value ? 'Quick Move In' : 'Presale'),
};

export default filterConfig;



// WEBPACK FOOTER //
// ./src/customFilters/IsQuickMoveIn.js